import {InternalLlmShimJournalFilter, LlmShimJournalId, Region} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const llmShimJournal = typedQuery(
  ["internal", "llm_shim_journal", "list", param<Region[]>("regions"), param<InternalLlmShimJournalFilter>("filter")],
  async (regions, filter) => {
    return await api.internal.llmShimJournal.listEntries(regions, filter);
  },
);

export const llmShimJournalPayload = typedQuery(
  ["internal", "llm_shim_journal", "payload", param<Region>("region"), param<LlmShimJournalId>("llmShimJournalId")],
  async (region, llmShimJournalId) => {
    return await api.internal.llmShimJournal.getPayload(region, llmShimJournalId);
  },
);
